/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchPosts.defs'
export { main as default } from './searchPosts.defs'
